<template>
  <div id="model-point-cloud">
    <iframe
      :src="relicInfo.pointCloudUrl"
      frameborder="0"
      class="cloud"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    relicInfo: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss">
#model-point-cloud {
  height: inherit;
  .cloud {
    width: 100%;
    height: inherit;
  }
}
</style>
